import classNames from "classnames/bind";
import React from "react";
import { Link } from "react-router-dom";
import { NavItem, NavPath } from "../../enums/nav";
import { About, AboutAnchor } from "../../pages/about";
import { Design, DesignAnchor } from "../../pages/design";
import { GuidelineAnchor, Guidelines } from "../../pages/guidelines";
import { Home, HomeAnchor } from "../../pages/home";
import { Research, ResearchAnchor } from "../../pages/research";
import { AnchorMenu } from "../anchor-menu";
import style from "./style.module.css";

export interface IMobileSidePanelProps {
    currAnchor: string;
    currNav: string;
    panelOpen: boolean;
    handleNavClick: (navItem: string) => void;
    handleMenuClick: (anchor: string) => void;
    closePanel: () => void;
}

export function MobileSidePanel(props: IMobileSidePanelProps) {
    const boundClasses = classNames.bind(style);
    const handleNavClick = (navItem: string) => {
        return () => {
            props.handleNavClick(navItem);
        }
    }

    const overlayClass = boundClasses(
        { [style.overlay]: true },
        { [style.active]: props.panelOpen }
    )

    const navClass = boundClasses(
        { [style.nav]: true },
        { [style.active]: props.panelOpen }
    )

    const homeClass = boundClasses(
        { [style.navItem]: true },
        { [style.selected]: props.currNav === NavPath.HOME }
    )

    const designClass = boundClasses(
        { [style.navItem]: true },
        { [style.selected]: props.currNav === NavPath.DESIGN }
    )

    const researchClass = boundClasses(
        { [style.navItem]: true },
        { [style.selected]: props.currNav === NavPath.RESEARCH }
    )

    const guidelineClass = boundClasses(
        { [style.navItem]: true },
        { [style.selected]: props.currNav === NavPath.GUIDELINES }
    )

    const aboutClass = boundClasses(
        { [style.navItem]: true },
        { [style.selected]: props.currNav === NavPath.ABOUT }
    )

    const handlePanelClick = (event: React.MouseEvent<HTMLElement>) => {
        event.stopPropagation();
        props.closePanel();
    }

    return (
        <section className={overlayClass}>
            <nav
                className={navClass}
                onClick={handlePanelClick}
            >
                <Link
                    className={homeClass}
                    to={NavPath.HOME}
                    onClick={handleNavClick(NavPath.HOME)}
                >
                    {NavItem.SOLUTION}
                </Link>
                {
                    props.currNav === NavPath.HOME ?
                        <AnchorMenu
                            selectedAnchor={props.currAnchor || HomeAnchor.OVERVIEW}
                            handleMenuClick={props.handleMenuClick}
                            anchorList={Home.ANCHOR_LIST.slice()}
                        />
                        : null
                }
                <Link
                    className={designClass}
                    to={NavPath.DESIGN}
                    onClick={handleNavClick(NavPath.DESIGN)}
                >
                    {NavItem.DESIGN}
                </Link>
                {
                    props.currNav === NavPath.DESIGN ?
                        <AnchorMenu
                            selectedAnchor={props.currAnchor || DesignAnchor.RECAP}
                            handleMenuClick={props.handleMenuClick}
                            anchorList={Design.ANCHOR_LIST.slice()}
                        />
                        : null
                }
                <Link
                    className={researchClass}
                    to={NavPath.RESEARCH}
                    onClick={handleNavClick(NavPath.RESEARCH)}
                >
                    {NavItem.RESEARCH}
                </Link>
                {
                    props.currNav === NavPath.RESEARCH ?
                        <AnchorMenu
                            selectedAnchor={props.currAnchor || ResearchAnchor.INCEPTION}
                            handleMenuClick={props.handleMenuClick}
                            anchorList={Research.ANCHOR_LIST.slice()}
                        />
                        : null
                }
                <Link
                    className={guidelineClass}
                    to={NavPath.GUIDELINES}
                    onClick={handleNavClick(NavPath.GUIDELINES)}
                >
                    {NavItem.GUIDELINES}
                </Link>
                {
                    props.currNav === NavPath.GUIDELINES ?
                        <AnchorMenu
                            selectedAnchor={props.currAnchor || GuidelineAnchor.INTRODUCTION}
                            handleMenuClick={props.handleMenuClick}
                            anchorList={Guidelines.ANCHOR_LIST.slice()}
                        />
                        : null
                }
                <Link
                    className={aboutClass}
                    to={NavPath.ABOUT}
                    onClick={handleNavClick(NavPath.ABOUT)}
                >
                    {NavItem.ABOUT}
                </Link>
                {
                    props.currNav === NavPath.ABOUT ?
                        <AnchorMenu
                            selectedAnchor={props.currAnchor || AboutAnchor.CAPSTONE}
                            handleMenuClick={props.handleMenuClick}
                            anchorList={About.ANCHOR_LIST.slice()}
                        />
                        : null
                }
                <a
                    className={style.navItem}
                    href="https://medium.com/mhci-capstone"
                    target="_blank"
                    rel="noreferrer"
                >{NavItem.BLOG}</a>

            </nav>
        </section>
    )
}